<template>
  <div id="app">
    <!-- 导航到/mutation -->
    <router-link to="/mutation"></router-link>
    <!-- 占位标签 -->
    <router-view></router-view>
  </div>
</template>

<script>

import Home from './components/Mutation.vue'

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
